import React from "react";
import ProntlifeColorido from "assets/logo/Logo_Colorida.svg";
import { FormspreeForm } from "components/form/FormspreeForm";
import { FooterContactsList } from "./components/FooterContactsList";

export const Footer = () => {
  return (
    <footer
      className="d-flex flex-column justify-content-md-between align-items-center mb-5 pb-5"
      id="contato"
      style={{ marginTop: "125px" }}
    >
      <h1 className={"footer-title text-primary font-weight-bold my-4"}>
        {" "}
        Fale com a gente
      </h1>
      <div className="text-md-left text-center my-md-0 my-lg-0 my-3"></div>
      <div className={"container"}>
        <div className="row">
          <div className="col-12 col-md-6 d-flex justify-content-center v-divider">
            <FormspreeForm />
          </div>
          <div className="col-12 col-md-6 d-flex flex-column pl-md-5 pt-5 pt-md-0">
            <img
              src={ProntlifeColorido}
              style={{ width: "230px", alignSelf: "flex-start" }}
              alt=""
              className={"image d-none d-md-block mb-4 pb-4 "}
            />
            <FooterContactsList />
          </div>
        </div>
        <div className="row mt-5">
          <div className="col">
            <p className="text-center">
              Ao acessar o ProntLife, você concorda com os nossos{" "}
              <a
                href="https://prontlife.com.br/terms/termos_de_uso_prontlife.pdf"
                rel="noopener noreferrer"
                target="_blank"
              >
                {" "}
                <b>Termos de Uso</b>
              </a>{" "}
              e com a nossa{" "}
              <a
                href="https://prontlife.com.br/privacy/politica_de_privacidade_seguranca_e_uso_de_dados_prontLife.pdf"
                rel="noopener noreferrer"
                target="_blank"
              >
                <b>Política de Privacidade</b>
              </a>
              ,{" "}
              <a
                href="https://prontlife.com.br/privacy/politica_de_privacidade_seguranca_e_uso_de_dados_prontLife.pdf"
                rel="noopener noreferrer"
                target="_blank"
              >
                <b>Segurança e Uso de Dados</b>.
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
